import { useState } from "react"
import { shouldInterrupt } from "../utils/safety"
import { checkSafety } from "../api/analyze"
import { SoftWarning } from "./SoftWarning"

interface Props {
  language: "tr" | "en"
  initialItems?: string[]
  onNext: (items: string[]) => void
}

export const Step1Load = ({ language, initialItems = [], onNext }: Props) => {
  const [text, setText] = useState("")
  const [items, setItems] = useState<string[]>(initialItems)
  const [showWarning, setShowWarning] = useState(false)

  const handleAdd = async () => {
    if (!text.trim()) return
    const newItem = text.trim()
    const newIndex = items.length
    setItems(prev => [...prev, newItem])
    setText("")
    setShowWarning(false)

    if (shouldInterrupt(newItem, language)) {
      setItems(prev => prev.filter((_, i) => i !== newIndex))
      setShowWarning(true)
      return
    }

    try {
      const safetyCheck = await checkSafety(newItem, language)
      if (!safetyCheck.safe) {
        setItems(prev => prev.filter((_, i) => i !== newIndex))
        setShowWarning(true)
      }
    } catch (error) {
      console.log("Safety check failed")
    }
  }

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") { e.preventDefault(); handleAdd() }
  }

  const handleRemove = (index: number) => {
    setItems(items.filter((_, i) => i !== index))
  }

  const t = language === "tr" ? {
    stepLabel: "Adım 1",
    title: "Bugün kafanda ne var?",
    placeholder: "Kafanı meşgul edenleri bırak…",
    addBtn: "Ekle",
    listLabel: "Liste",
    continueBtn: "Devam Et",
  } : {
    stepLabel: "Step 1",
    title: "What's on your mind today?",
    placeholder: "Drop what's on your mind…",
    addBtn: "Add",
    listLabel: "List",
    continueBtn: "Continue",
  }

  return (
    <div>
      <div className="step-label">{t.stepLabel}</div>
      <div className="step-title">{t.title}</div>

      <textarea
        value={text}
        onChange={(e) => setText(e.target.value)}
        onKeyPress={handleKeyPress}
        placeholder={t.placeholder}
        rows={3}
      />

      <button onClick={handleAdd} className="btn-add">
        {t.addBtn}
      </button>

      {showWarning && (
        <SoftWarning language={language} onDismiss={() => setShowWarning(false)} />
      )}

      {items.length > 0 && (
        <div>
          <div className="section-label">{t.listLabel} ({items.length})</div>
          {items.map((item, i) => (
            <div key={i} className="list-item">
              <div className="list-item-bullet" />
              <span className="list-item-text">{item}</span>
              <button className="remove-btn" onClick={() => handleRemove(i)}>×</button>
            </div>
          ))}
        </div>
      )}

      {items.length >= 2 && (
        <button
          onClick={() => onNext(items)}
          className="btn-primary"
          style={{ marginTop: "20px" }}
        >
          {t.continueBtn}
        </button>
      )}
    </div>
  )
}